"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var currency = require("currency.js");
function formatCurrencyFromCents(cents) {
    return currency(cents, { fromCents: true }).format();
}
exports.formatCurrencyFromCents = formatCurrencyFromCents;
//# sourceMappingURL=formatNumber.js.map